/*
 * LienzoMoments — cuanto pierde una foto en cada formato (DT-11)
 * ---------------------------------------------------------------------------
 * Una sola definicion del criterio de encuadre para todo el tema. La usan:
 *
 *   assets/lienzomoments-upload.js           la ficha del cuadro
 *   assets/lienzomoments-photo-services.js   /pages/restaurar-y-colorizar
 *
 * Antes la formula vivia dentro de upload.js. Se saco aqui cuando la pagina
 * de servicios sueltos necesito decidir con el mismo criterio que formato de
 * cuadro ofrecerle a una foto: dos copias de la misma regla acaban diciendo
 * cosas distintas el dia que alguien toca una sola.
 *
 * Lo que NO vive aqui es el umbral. Cada pagina lo lee de su propio ajuste
 * (`ratio_tolerance` en el bloque de subida y en la seccion de servicios),
 * porque una plantilla de pagina no puede leer los ajustes de un bloque del
 * producto. Los dos arrancan en 15 y tienen que moverse juntos.
 */
(() => {
  'use strict';

  if (window.LMFit) return;

  /** "4:3" -> 1.333. */
  const ratioOf = (format) => {
    const [a, b] = String(format).split(':').map(Number);
    return a && b ? a / b : null;
  };

  /** Proporcion sin orientacion: siempre >= 1. */
  const flat = (ratio) => (ratio >= 1 ? ratio : 1 / ratio);

  /**
   * Parte de la foto que se pierde al imprimirla en un formato, con el
   * formato girado a la orientacion de la foto: 1 - menor / mayor. Una
   * cuadrada en 3:2 pierde 33 %; una 3:4 de celular en 3:2, 11 %.
   */
  const crop = (ratio, format) => {
    const f = ratioOf(format);
    if (!f) return 1;
    const p = flat(ratio);
    return 1 - Math.min(p, f) / Math.max(p, f);
  };

  window.LMFit = { ratioOf, flat, crop };
})();
